import React from "react";
import { Mail } from "lucide-react";
import "./Footer.css";

export const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-column">
            <div className="footer-logo">
              <span className="footer-logo-text">Singularity</span>
              <span className="footer-logo-innovations">Innovations</span>
            </div>
            <p className="footer-tagline">
              Pioneering the future of consumer electronics with innovation and excellence
            </p>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><a href="#hero">About Us</a></li>
              <li><a href="#why-choose-us">Why Choose Us</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="#hero">Careers</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Contact Info</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <Mail size={16} />
                <span>contact@singularityipl.in</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 Singularity Innovations Private Limited. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="#hero">Privacy Policy</a>
            <span className="footer-divider">•</span>
            <a href="#hero">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
